import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ClientSettingsWithDetails, LanguageSettings } from "../../api/sms-api";
import {
  NonPaginatedCRUDState,
  initialNonPaginatedCRUDState,
} from "store/CRUDStore";
import { ErrorWrapper } from "errors/errors";

interface ClientSettingsState
  extends NonPaginatedCRUDState<ClientSettingsWithDetails> {
  items: Array<ClientSettingsWithDetails>;
  languageSettings: Array<LanguageSettings>;
  getLanguageSettingsListLoading: boolean;
}

export const initialState: ClientSettingsState = {
  ...initialNonPaginatedCRUDState,
  languageSettings: [],
  getLanguageSettingsListLoading: false,
};

export const slice = createSlice({
  name: "clientSettings",
  initialState,
  reducers: {
    listClientSettingsStart: (state) => {
      state.listLoading = true;
    },
    listClientSettingsSuccess: (state, action) => {
      state.items = action.payload;
      state.listLoading = false;
    },
    listClientSettingsError: (state, _action: PayloadAction<ErrorWrapper>) => {
      state.listLoading = false;
    },
    addOrUpdateClientSettingsStart: (state) => {
      state.createLoading = true;
    },
    addOrUpdateClientSettingsSuccess: (state) => {
      state.createLoading = false;
    },
    addOrUpdateClientSettingsError: (
      state,
      _action: PayloadAction<ErrorWrapper>
    ) => {
      state.createLoading = false;
    },
    getLanguageSettingsListStart: (state) => {
      state.getLanguageSettingsListLoading = true;
    },
    getLanguageSettingsListSuccess: (
      state,
      action: PayloadAction<Array<LanguageSettings>>
    ) => {
      state.languageSettings = action.payload;
      state.getLanguageSettingsListLoading = false;
    },
    getLanguageSettingsListError: (state) => {
      state.getLanguageSettingsListLoading = false;
    },
  },
});

export const {
  listClientSettingsStart,
  listClientSettingsSuccess,
  listClientSettingsError,
  addOrUpdateClientSettingsStart,
  addOrUpdateClientSettingsSuccess,
  addOrUpdateClientSettingsError,
  getLanguageSettingsListStart,
  getLanguageSettingsListSuccess,
  getLanguageSettingsListError,
} = slice.actions;

export default slice.reducer;
